// Utils
import { isExternalURL } from '@/lib/utils'
// Hooks
import { useRouter } from 'next/navigation'
import { useTransition } from 'react'
import { useBackdrop } from '@/contexts/BackdropProvider'

export default function useNavigate() {
  const showBackdrop = useBackdrop()
  const [isPending, startTransition] = useTransition()
  const router = useRouter()
  const navigate = (route: string, options = {}) => {
    if (isExternalURL(route)) {
      showBackdrop(false)
      window.location.href = route
    } else {
      showBackdrop(true)
      startTransition(() => {
        router.push(route, options)
        showBackdrop(false)
      })
    }
  }
  return { isPending, navigate }
}
